import React, { useRef } from "react";
import SVG from "react-inlinesvg";
import {
  convertMinutesToHours,
  iconPath,
} from "../../../../constants/constants";
import { useIntl } from "react-intl";
import { CiCalendar } from "react-icons/ci";
import { IoMdTime } from "react-icons/io";
import { MdOutlineFactCheck } from "react-icons/md";
import { IoCalendarOutline } from "react-icons/io5";
import { CiCreditCard1 } from "react-icons/ci";
import { CallAPI } from "../../../../config/api/ApiConfig";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Else, If, Then } from "react-if";
import { PATH_PAGE } from "../../../../routes/Paths";

export const DetailsCard = () => {
  const path = iconPath();
  const inputRef = useRef(null);
  const { messages } = useIntl();
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const { data: booking } = CallAPI({
    name: ["reviewClient", id],
    url: "/mentor/v1/bookings/" + id,
    refetchOnWindowFocus: false,
    enabled: true,
    select: (res) => res?.data?.data,
  });

  const handleCopy = () => {
    if (inputRef.current) {
      inputRef.current.select();
      navigator.clipboard
        .writeText(inputRef?.current?.value)
        .then(() => {
          toast.success(messages["text_copied"]);
        })
        .catch((error) => {
          toast.error("Unable to copy: ", error);
        });
    }
  };

  const { refetch: addNewMessage } = CallAPI({
    name: "sendMsgFromMentor",
    url: "/mentor/v1/chats",
    method: "post",
    body: {
      message: "Hello",
      booking_id: booking?.id,
      receiver_id: booking?.client?.id,
    },
    enabled: false,
    refetchOnWindowFocus: false,
    select: (res) => res?.data?.data,
    onSuccess: (res) => {
      navigate(`${PATH_PAGE?.chat}?id=${res?.id}`);
    },
  });

  const renderTypeOfService = (type, sessionNum) => {
    if (type === "private_session") {
      return messages["services.individual"];
    }
    if (type === "group_session") {
      return messages["group_session"];
    }
    if (type === "private_sessions_package") {
      return `${sessionNum} ${messages["session"]}`;
    }
  };

  const dataForDetailsCard = {
    name: "Session Name",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    date: "2025-01-01",
    time: "10:00",
    price: "100",
    content: "10 sessions",
    duration: "1 hour",
    status: "Scheduled",
    attendanceStatus: "Attended",
    period: "1 month",
  };

  return (
    <div className="row">
      <div className="col-md-12 mb-3">
        <div className="details_card min-height-unset">
          <h3>{dataForDetailsCard?.name}</h3>
          <p>{dataForDetailsCard?.description}</p>
        </div>
      </div>
      <div className="col-md-12 mb-3">
        <div className="details_card min-height-unset">
          <div className="row user_details align-items-center mb-3">
            <div className="col-md-3">
              <div className="d-flex align-items-center gap-1 mb-3">
                <CiCalendar
                  style={{ color: "#3A4E7B", width: "25px", height: "25px" }}
                />
                <p style={{ color: "#3A4E7B" }} className="mb-0 fs-6">
                  {dataForDetailsCard?.date}
                </p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <IoMdTime
                  style={{ color: "#3A4E7B", width: "25px", height: "25px" }}
                />
                <p style={{ color: "#3A4E7B" }} className="mb-0 fs-6">
                  {dataForDetailsCard?.duration}
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="d-flex align-items-center gap-1 mb-3">
                <MdOutlineFactCheck
                  style={{ color: "#3A4E7B", width: "25px", height: "25px" }}
                />
                <p style={{ color: "#3A4E7B" }} className="mb-0 fs-6">
                  {dataForDetailsCard?.content}
                </p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <IoCalendarOutline
                  style={{ color: "#3A4E7B", width: "25px", height: "25px" }}
                />
                <p style={{ color: "#3A4E7B" }} className="mb-0 fs-6">
                  {dataForDetailsCard?.period}
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-end align-items-start">
              <div className="d-flex align-items-center gap-1 mb-3">
                <CiCreditCard1
                  style={{ color: "#3A4E7B", width: "25px", height: "25px" }}
                />
                <p style={{ color: "#3A4E7B" }} className="fw-bold mb-0 fs-4">
                  {dataForDetailsCard?.price}
                </p>
                <p style={{ color: "#3A4E7B" }} className="fs-6">
                  SAR
                </p>
              </div>
            </div>
          </div>

          <If condition={booking?.status == "scheduled"}>
            <Then>
              <h3>{messages["zoom_link"]}</h3>
              <div className="input-group p-1 zoom_input justify-content-between">
                <button className="btn border-0" onClick={handleCopy}>
                  <span className="input-group-text bg-transparent border-0 p-0">
                    <SVG src={`${path}link-alt.svg`} />
                  </span>
                </button>
                <span>
                  <input
                    className="form-control border-0 bg-transparent"
                    placeholder="Zoom Link"
                    value={booking?.zoom_link}
                    disabled
                    ref={inputRef}
                    hidden
                  />
                  {booking?.zoom_link}
                </span>
                <Link
                  className="btn border-0"
                  target="_blank"
                  to={`${booking?.zoom_link}`}
                >
                  <span className="input-group-text bg-transparent border-0 p-0">
                    <SVG src={`${path}files.svg`} />
                  </span>
                </Link>
              </div>
            </Then>
          </If>
        </div>
      </div>
    </div>
  );
};
